module.exports = __webpack_public_path__ + "static/media/Mix_inicio_testigo1_opinion.d4213ca2.png";